// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockbutton-link a {
	background-color: transparent !important;
	color: var(--scouting-america-white) !important;

	width: 100%;
	height: 100%;

	padding-left: 16px;
	padding-right: 16px;
	padding-top: 8px;
	padding-bottom: 8px;

	display: flex;
	align-items: center;
	justify-content: space-around;

	border: 2px solid var(--scouting-america-pale-blue) !important;
	border-radius: 6px;

	font-size: var(--body-normal-size);
	font-family: var(--font-1);
	font-weight: bolder;

	text-decoration: none;
	white-space: nowrap;

	transition: all 0.25s ease;
}
	.blockbutton-link a:hover {
		background-color: var(--scouting-america-red) !important;
		color: var(--scouting-america-white) !important;

		box-shadow: 0 4px 0px var(--scouting-america-pale-blue);

		transform: translateY(-4px);
	}
	.blockbutton-link a:visited {
		color: var(--scouting-america-white) !important;

		border: 2px solid var(--scouting-america-pale-blue);

		text-decoration: none;
	}



.barbutton-link a {
	background-color: transparent !important;
	color: var(--scouting-america-white) !important;

	width: 100%;
	height: 100%;

	position: relative;

	display: flex;
	align-items: center;
	justify-content: center;

	font-family: var(--font-1);
	font-size: var(--body-normal-size);
	font-weight: 600;

	text-decoration: none !important;

	transition: all 0.25s ease;
}
	.barbutton-link a:visited {
		color: var(--scouting-america-white) !important;

		text-decoration: none;
	}
	.barbutton-link a:hover {
		background-color: color-mix(
			in srgb,
			var(--scouting-america-red) 10%,
			transparent
		) !important;
		color: var(--scouting-america-white) !important;
	}
	.barbutton-link a::after {
		content: '';

		background-color: var(--scouting-america-red) !important;

		width: 0px;
		height: 3px;

		position: absolute;
		bottom: 0;
		left: 50%;

		transform: translateX(-50%);
		transition: all 0.25s ease;
	}
	.barbutton-link a:hover::after {
		width: 80%;
	}`, "",{"version":3,"sources":["webpack://./src/components/Buttons/Buttons.css"],"names":[],"mappings":"AAAA;CACC,wCAAwC;CACxC,+CAA+C;;CAE/C,WAAW;CACX,YAAY;;CAEZ,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;;CAEnB,aAAa;CACb,mBAAmB;CACnB,6BAA6B;;CAE7B,8DAA8D;CAC9D,kBAAkB;;CAElB,kCAAkC;CAClC,0BAA0B;CAC1B,mBAAmB;;CAEnB,qBAAqB;CACrB,mBAAmB;;CAEnB,0BAA0B;AAC3B;CACC;EACC,wDAAwD;EACxD,+CAA+C;;EAE/C,uDAAuD;;EAEvD,2BAA2B;CAC5B;CACA;EACC,+CAA+C;;EAE/C,mDAAmD;;EAEnD,qBAAqB;CACtB;;;;AAID;CACC,wCAAwC;CACxC,+CAA+C;;CAE/C,WAAW;CACX,YAAY;;CAEZ,kBAAkB;;CAElB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;;CAEvB,0BAA0B;CAC1B,kCAAkC;CAClC,gBAAgB;;CAEhB,gCAAgC;;CAEhC,0BAA0B;AAC3B;CACC;EACC,+CAA+C;;EAE/C,qBAAqB;CACtB;CACA;EACC;;;;cAIY;EACZ,+CAA+C;CAChD;CACA;EACC,WAAW;;EAEX,wDAAwD;;EAExD,UAAU;EACV,WAAW;;EAEX,kBAAkB;EAClB,SAAS;EACT,SAAS;;EAET,2BAA2B;EAC3B,0BAA0B;CAC3B;CACA;EACC,UAAU;CACX","sourcesContent":[".blockbutton-link a {\n\tbackground-color: transparent !important;\n\tcolor: var(--scouting-america-white) !important;\n\n\twidth: 100%;\n\theight: 100%;\n\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n\tpadding-top: 8px;\n\tpadding-bottom: 8px;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n\n\tborder: 2px solid var(--scouting-america-pale-blue) !important;\n\tborder-radius: 6px;\n\n\tfont-size: var(--body-normal-size);\n\tfont-family: var(--font-1);\n\tfont-weight: bolder;\n\n\ttext-decoration: none;\n\twhite-space: nowrap;\n\n\ttransition: all 0.25s ease;\n}\n\t.blockbutton-link a:hover {\n\t\tbackground-color: var(--scouting-america-red) !important;\n\t\tcolor: var(--scouting-america-white) !important;\n\n\t\tbox-shadow: 0 4px 0px var(--scouting-america-pale-blue);\n\n\t\ttransform: translateY(-4px);\n\t}\n\t.blockbutton-link a:visited {\n\t\tcolor: var(--scouting-america-white) !important;\n\n\t\tborder: 2px solid var(--scouting-america-pale-blue);\n\n\t\ttext-decoration: none;\n\t}\n\n\n\n.barbutton-link a {\n\tbackground-color: transparent !important;\n\tcolor: var(--scouting-america-white) !important;\n\n\twidth: 100%;\n\theight: 100%;\n\n\tposition: relative;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tfont-family: var(--font-1);\n\tfont-size: var(--body-normal-size);\n\tfont-weight: 600;\n\n\ttext-decoration: none !important;\n\n\ttransition: all 0.25s ease;\n}\n\t.barbutton-link a:visited {\n\t\tcolor: var(--scouting-america-white) !important;\n\n\t\ttext-decoration: none;\n\t}\n\t.barbutton-link a:hover {\n\t\tbackground-color: color-mix(\n\t\t\tin srgb,\n\t\t\tvar(--scouting-america-red) 10%,\n\t\t\ttransparent\n\t\t) !important;\n\t\tcolor: var(--scouting-america-white) !important;\n\t}\n\t.barbutton-link a::after {\n\t\tcontent: '';\n\n\t\tbackground-color: var(--scouting-america-red) !important;\n\n\t\twidth: 0px;\n\t\theight: 3px;\n\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 50%;\n\n\t\ttransform: translateX(-50%);\n\t\ttransition: all 0.25s ease;\n\t}\n\t.barbutton-link a:hover::after {\n\t\twidth: 80%;\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
